import { Schema } from "effect";
export const TimeslotLock = Schema.Struct({
    lockedByIId: Schema.String,
    recruiterAADID: Schema.String,
    requestedStartTime: Schema.Unknown,
    requestedEndTime: Schema.Unknown,
    createdAt: Schema.Unknown,
    lockExpiresAt: Schema.Unknown,
    lockOwnerToken: Schema.String,
    timeToLive: Schema.Unknown,
});
